import { render, staticRenderFns } from "./pricingFive.vue?vue&type=template&id=702d0bc7&"
import script from "./pricingFive.vue?vue&type=script&lang=js&"
export * from "./pricingFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports